import React from 'react';
import {
    Skilt,
    Skiltfarge,
    Skiltstorrelse,
} from '../../../components/skilt/Skilt';
import { useApptekster } from '../../../contexts/ApptekstContext';

export enum Skiltformat {
    SS = 'personlig-kjennemerke.skiltformat.ss',
    SH = 'personlig-kjennemerke.skiltformat.sh',
    LS = 'personlig-kjennemerke.skiltformat.ls',
    LH = 'personlig-kjennemerke.skiltformat.lh',
    US = 'personlig-kjennemerke.skiltformat.us',
    ST = 'personlig-kjennemerke.skiltformat.st',
}

export enum Skiltbeskrivelse {
    ORDINART = 'personlig-kjennemerke.skiltfarge.hvit-bakgrunn-svart-skrift',
    VAREBIL_KLASSE_2 = 'personlig-kjennemerke.skiltfarge.gronn-bakgrunn-svart-skrift',
    RALLY_TRIAL_ENDURO = 'personlig-kjennemerke.skiltfarge.svart-bakgrunn-hvit-skrift',
    UTENFOR_OFFENTLIG_VEG = 'personlig-kjennemerke.skiltfarge.svart-bakgrunn-gul-skrift',
}

export const tilSkiltfarge = (kjennemerketype?: string) => {
    switch (kjennemerketype) {
        case 'VAREBIL_KLASSE_2':
            return Skiltfarge.VarebilKlasse2;
        case 'UTENFOR_OFFENTLIG_VEG':
            return Skiltfarge.UtenforOffentligVeg;
        case 'RALLY_TRIAL_ENDURO':
            return Skiltfarge.RallyTrialEnduro;
        default:
            return Skiltfarge.Ordinaert;
    }
};

type SkiltvisningProps = {
    kjennemerkestorrelser: { foran: string; bak: string };
    kjennemerketype: string;
    modus?: 'enkel' | 'detaljer';
    tegnkombinasjon: string;
    className?: string;
};

export const Skiltvisning = ({
    className,
    kjennemerkestorrelser,
    kjennemerketype,
    modus = 'enkel',
    tegnkombinasjon,
}: SkiltvisningProps) => {
    const t = useApptekster();
    const skiltfarge = tilSkiltfarge(kjennemerketype);

    return (
        <div className={className}>
            {kjennemerkestorrelser.foran && (
                <>
                    {modus === 'detaljer' && (
                        <>
                            <p className="svv-h5">
                                {t(
                                    'personlig-kjennemerke.bestill.forhandsvisning.foran',
                                )}
                            </p>
                            <p>
                                {t(
                                    Skiltformat[
                                        kjennemerkestorrelser.foran as keyof typeof Skiltformat
                                    ],
                                )}
                            </p>
                            <p className="spacing-bottom--xxsmall">
                                {t(
                                    Skiltbeskrivelse[
                                        kjennemerketype as keyof typeof Skiltbeskrivelse
                                    ],
                                )}
                            </p>
                        </>
                    )}
                    <Skilt
                        storrelse={
                            Skiltstorrelse[
                                kjennemerkestorrelser.foran as keyof typeof Skiltstorrelse
                            ]
                        }
                        farge={skiltfarge}
                        tegnkombinasjon={tegnkombinasjon!}
                    />
                </>
            )}
            {kjennemerkestorrelser.bak && (
                <>
                    {modus === 'detaljer' && (
                        <>
                            <p className="svv-h5">
                                {t(
                                    'personlig-kjennemerke.bestill.forhandsvisning.bak',
                                )}{' '}
                            </p>
                            <p>
                                {t(
                                    Skiltformat[
                                        kjennemerkestorrelser.bak as keyof typeof Skiltformat
                                    ],
                                )}
                            </p>
                            <p className="spacing-bottom--xxsmall">
                                {t(
                                    Skiltbeskrivelse[
                                        kjennemerketype as keyof typeof Skiltbeskrivelse
                                    ],
                                )}
                            </p>
                        </>
                    )}
                    <Skilt
                        storrelse={
                            Skiltstorrelse[
                                kjennemerkestorrelser.bak as keyof typeof Skiltstorrelse
                            ]
                        }
                        farge={skiltfarge}
                        tegnkombinasjon={tegnkombinasjon!}
                    />
                </>
            )}
        </div>
    );
};
